export enum MessageStatusEnum {
    _new = 'new',
    read = 'read'
}
